export default {
  displayName: 'Header',
  modules: ['Hero', 'StickyNav'],
};
